import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action"];
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { HR } from 'foundations-components/transitional/components/HR';
import { Small } from 'foundations-components/transitional/components/Small';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { Section as FoundationsSection } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useTheme } from 'foundations-theming/utils';
import { parse as parseParams } from 'hub-http/helpers/params';
import SharedData from 'marketplace-ui-apps-core/details/components/SharedData';
import { Requirements } from 'marketplace-ui-apps-core/details/components/sidebar/Requirements';
import { useAppInstallability } from 'marketplace-ui-apps-core/installability/hooks/useAppInstallability';
import MetaOpenGraph from 'marketplace-ui-common/components/elements/MetaOpenGraph';
import MetaTwitter from 'marketplace-ui-common/components/elements/MetaTwitter';
import DocumentHead from 'marketplace-ui-common/components/portals/DocumentHead';
import PrerenderReady from 'marketplace-ui-common/components/prerender/PrerenderReady';
import { useHeaderTabs } from 'marketplace-ui-common/hooks/useHeaderTabs';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useScrollEventListener } from 'marketplace-ui-common/hooks/useScrollEventListener';
import { useScrollToTop } from 'marketplace-ui-common/hooks/useScrollToTop';
import { useWindowDimensionsContext } from 'marketplace-ui-common/hooks/useWindowDimensionsContext';
import InnerSection from 'marketplace-ui-common/layout/components/InnerSection';
import InnerSectionHeading from 'marketplace-ui-common/layout/components/InnerSectionHeading';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import { MainSectionHeading } from 'marketplace-ui-common/layout/components/MainSectionHeading';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { MediaCarousel } from 'marketplace-ui-details/media/MediaCarousel';
import { useUsageTracker } from 'marketplace-ui-tracking';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import NavMarker from 'react-rhumb/NavMarker';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { AppRelatedInstallStatsSection } from '../components/detail/AppRelatedInstallStatsSection';
import { FeatureCards } from '../components/detail/overview/FeatureCards';
import { IntegrationFeatures } from '../components/detail/overview/IntegrationFeatures';
import { AppDetails } from '../components/detail/overview/sidebar/AppDetails';
import { FeatureCompatibilityModal } from '../components/detail/overview/sidebar/FeatureCompatibilityModal';
import { LegacyFeatureCompatibilityModal } from '../components/detail/overview/sidebar/LegacyFeatureCompatibilityModal';
import Reviews from '../components/detail/reviews/Reviews';
import { NAV_BAR_HEIGHT_INT } from '../constants';
import { useAppContext } from '../context/AppContext';
import { useLeadGenContext } from '../context/LeadGenContext';
import { getFullHref } from '../utils/history';
import { useAppRelatedInstallStats } from '../utils/hooks/useAppRelatedInstallStats';
import { useListingView } from '../utils/hooks/useListingView';
import { useSocialScreenshotUrl } from '../utils/hooks/useSocialScreenshot';
import { getAllReviewsUrl, getFormattedUrl, getListingDetailUrl } from '../utils/urls';
// @ts-expect-error untyped dependency
import localeComparator from 'I18n/utils/localeComparator';
import { PublicOnly, getHasZorseChatScope, getHasZorseWebticketScope, getIsCustomer, getIsPublic
// @ts-expect-error untyped dependency
} from '../selectors/auth';
// @ts-expect-error untyped dependency
import { openHelpWidget } from '../utils/zorse';
// @ts-expect-error untyped dependency
import { useParsedPathParams } from '../utils/hooks/useParsedPathParams';
// @ts-expect-error untyped dependency
import AppIntegrations from '../components/detail/overview/AppIntegrations';
// @ts-expect-error untyped dependency
import Benefits from '../components/detail/overview/Benefits';
// @ts-expect-error untyped dependency
import CanonicalLink from '../components/elements/CanonicalLink';
// @ts-expect-error untyped dependency
import Contact from '../components/detail/overview/sidebar/Contact';
// @ts-expect-error untyped dependency
import Header, { TAB_IDS } from '../components/detail/Header';
// @ts-expect-error untyped dependency
import HubSpotFeatures from '../components/detail/overview/HubSpotFeatures';
// @ts-expect-error untyped dependency
import Privacy from '../components/detail/overview/sidebar/Privacy';
// @ts-expect-error untyped dependency
import Resources from '../components/detail/overview/sidebar/Resources';
// @ts-expect-error untyped dependency
import Pricings from '../components/detail/pricing/Pricings';
// @ts-expect-error untyped dependency
import StorefrontFilters from '../records/StorefrontFilters';
// @ts-expect-error untyped dependency
import { getIsUngatedForUnifiedDetails } from '../selectors/auth';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncCtaBanner = Loadable({
  loader: () => import(
  // @ts-expect-error untyped dependencys
  /* webpackChunkName: 'detail-cta-banner' */
  './CtaBanner')
});
const SidebarSection = props => /*#__PURE__*/_jsx(InnerSection, Object.assign({}, props, {
  compact: true
}));
const Section = ({
  children,
  label
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx("dt", {
    children: label
  }), /*#__PURE__*/_jsx("dd", {
    children: children
  })]
});
export function AppDetailsPage({
  isAdminPreview = false
}) {
  const trellisTheme = useTheme();
  const appContext = useAppContext();
  const location = useLocation();
  const {
    pathname,
    search
  } = location;
  const params = useParams();
  const {
    path,
    url
  } = useRouteMatch();
  const {
    height: windowHeight
  } = useWindowDimensionsContext();
  const [{
    published,
    source,
    language: languageQuery,
    embeddedFeatureCompatibility,
    ref: referrer
  }] = useState(parseParams(search.slice(1)));
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.MD]: false
    }
  });
  useScrollToTop(pathname);
  const {
    slug
  } = useParsedPathParams(params);
  const isUngatedForUnifiedDetails = useSelector(getIsUngatedForUnifiedDetails);
  const hasZorseChatScope = useSelector(getHasZorseChatScope);
  const hasZorseWebticketScope = useSelector(getHasZorseWebticketScope);
  const isCustomer = useSelector(getIsCustomer);
  const history = useHistory();
  const {
    listingView,
    getListingViewEventProperties
  } = useListingView(isUngatedForUnifiedDetails);
  const langCode = getLang();
  const isPreview = published === 'false' || path === '/_preview/:offeringId' || isAdminPreview;
  const isPublic = useSelector(getIsPublic);
  const isReviewLink = path.includes('/:slug/write-review');
  const tracker = useUsageTracker();
  const [pageViewTracked, setPageViewTracked] = useState(false);
  const scrollOffset = NAV_BAR_HEIGHT_INT + windowHeight / 2;
  const {
    calculateActiveTab,
    scrollToTabSection,
    activeTab
  } = useHeaderTabs(Object.values(TAB_IDS), scrollOffset);
  useScrollEventListener(calculateActiveTab);
  const {
    agencyPricingUrl,
    appIntegrations,
    appLanguages,
    appUrl,
    benefits,
    casesUrl,
    categoryV2,
    chatUrl,
    companyName,
    companyUrl,
    currency,
    dashworks,
    dataSyncHowItWorks,
    dataSyncInfo,
    dataSyncs,
    email,
    facebookUrl,
    features,
    hubSpotFeatures,
    iconUrl,
    interactionDetails,
    id,
    integrationFeatures,
    keywords,
    name,
    neededScopeGroups,
    offering: {
      credentials,
      connectionType,
      homemade,
      installsCount,
      portalId: offeringPortalId
    },
    offeringId,
    opsHub,
    phone,
    pricingUrl,
    pricings,
    privacy2Url,
    privacy3Url,
    privacyUrl,
    screenshots,
    setupUrl,
    supportLanguages,
    supportUrl,
    tagline,
    termsUrl,
    thumbnailUrl,
    tiers,
    updatedAt,
    videoUrl
  } = listingView;
  const {
    installability
  } = useAppInstallability({
    appContext,
    offeringId: offeringId !== null && offeringId !== void 0 ? offeringId : 0,
    published: !isPreview
  });
  const appId = listingView.getAppId();
  const [featureCompatibilityModalOpen, setFeatureCompatibilityModalOpen] = useState(!isPublic && embeddedFeatureCompatibility === 'true');
  const {
    runLeadGen
  } = useLeadGenContext();
  const documentTitle = useMemo(() => {
    return unescapedText('appMarketplace.detail.htmlTitle', {
      name
    });
  }, [name]);
  const preferredLanguage = useMemo(() => {
    return isPreview ? languageQuery || 'en' : langCode;
  }, [langCode, languageQuery, isPreview]);
  const eventProperties = useMemo(() => {
    let screen;
    if (isPreview) {
      screen = 'detail preview';
    } else if (isReviewLink) {
      screen = 'detail review';
    } else {
      screen = 'detail';
    }
    return Object.assign({}, getListingViewEventProperties(), {
      slug,
      screen,
      preferredLanguage
    });
  }, [getListingViewEventProperties, isPreview, isReviewLink, preferredLanguage, slug]);
  const trackEvent = useCallback((eventName, properties = {}) => {
    tracker === null || tracker === void 0 || tracker.track(eventName, Object.assign({}, properties, eventProperties));
  }, [eventProperties, tracker]);
  const trackConnectButtonClick = useCallback(() => {
    trackEvent('listing-detail-click-connect');
  }, [trackEvent]);
  const trackInteraction = useCallback((action, properties = {}) => {
    trackEvent('listing-detail-interaction', Object.assign({
      action
    }, properties));
  }, [trackEvent]);

  // marketplace-ui-reviews uses a single object that contains all the properties.
  const trackReviewInteraction = useCallback(eventProps => {
    trackEvent('listing-detail-interaction', Object.assign({}, eventProps, eventProperties));
  }, [eventProperties, trackEvent]);

  // TODO: remove after conv-0002 experiment
  // this is only here for the sake of the experiment-------------------
  const appRelatedInstallStats = useAppRelatedInstallStats(offeringId);
  const hasAppRelatedInstallStats = appRelatedInstallStats.country || appRelatedInstallStats.industry || appRelatedInstallStats.plan;
  const getAppRelatedInstallStatValue = useCallback(stat => {
    return appRelatedInstallStats[stat] && Object.values(appRelatedInstallStats[stat])[0];
  }, [appRelatedInstallStats]);
  // ----------------------------------------------------------------------
  const trackPageview = useCallback((properties = {}) => {
    let eventName;
    if (isPreview) {
      eventName = 'listing-detail-preview-pageview';
    } else if (isReviewLink) {
      eventName = 'listing-detail-review-pageview';
    } else {
      eventName = 'listing-detail-pageview';
    }
    trackEvent(eventName, Object.assign({}, properties, {
      showAppRelatedInstallStats: !!hasAppRelatedInstallStats,
      appRelatedIndustryStat: getAppRelatedInstallStatValue('industry'),
      appRelatedCountryStat: getAppRelatedInstallStatValue('country'),
      appRelatedPlanStat: getAppRelatedInstallStatValue('plan'),
      referrer: referrer || undefined,
      preferredLanguage,
      source
    }));
  }, [isPreview, isReviewLink, trackEvent, hasAppRelatedInstallStats, getAppRelatedInstallStatValue, referrer, preferredLanguage, source]);
  const pricingLastUpdated = useMemo(() => {
    if (pricings[0] && pricings[0].updatedAt) {
      return pricings[0].updatedAt;
    }
    return updatedAt;
  }, [pricings, updatedAt]);
  const getFilterLink = useCallback((filterKey, filterValue) => {
    return StorefrontFilters.from({
      [filterKey]: [filterValue]
    }).toLocation();
  }, []);
  useEffect(() => {
    document.title = documentTitle;
    if (!pageViewTracked && !appRelatedInstallStats.installStatsLoading) {
      trackPageview();
      setPageViewTracked(true);
    }
  }, [appRelatedInstallStats.installStatsLoading, documentTitle, pageViewTracked, trackPageview]);

  // Reset the ref query param to avoid tracking the wrong referrer when the user refreshes
  useEffect(() => {
    if (referrer) {
      history.replace({
        search: ''
      });
    }
  }, [history, referrer]);
  const mediaCarouselItems = useMemo(() => {
    const carouselItems = screenshots.map(s => ({
      type: 'image',
      source: s.imageUrl,
      alt: s.altText ? s.altText : ''
    }));
    if (videoUrl) {
      carouselItems.unshift({
        type: 'video',
        source: videoUrl,
        alt: '',
        thumbnailUrl
      });
    }
    return carouselItems;
  }, [screenshots, thumbnailUrl, videoUrl]);
  const renderedResourcesSection = useMemo(() => /*#__PURE__*/_jsxs(SidebarSection, {
    "data-test-id": "details-resources",
    children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.overview.sidebar.resources.headingText"
      })
    }), /*#__PURE__*/_jsx(Resources, {
      casesUrl: casesUrl,
      onTrackInteraction: trackInteraction,
      setupUrl: setupUrl,
      companyUrl: companyUrl
    })]
  }), [casesUrl, companyUrl, trackInteraction, setupUrl]);
  const renderedSupportLanguagesList = useMemo(() => /*#__PURE__*/_jsx(FormattedList, {
    children: supportLanguages.map(languageCode => [languageCode, `SharedI18nStrings.languageNames.${languageCode}`]).sort(([__, languageANameI18nKey], [___, languageBNameI18nKey]) => localeComparator(unescapedText(languageANameI18nKey), unescapedText(languageBNameI18nKey))).map(([languageCode, languageNameI18nKey]) => /*#__PURE__*/_jsx(FormattedMessage, {
      message: languageNameI18nKey
    }, languageCode))
  }), [supportLanguages]);
  const renderedSupportSection = useMemo(() => /*#__PURE__*/_jsxs(SidebarSection, {
    "data-test-id": "details-support",
    children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
      children: homemade ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.overview.sidebar.support.homemadeHeadingText",
        options: {
          name
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.overview.sidebar.support.headingText",
        options: {
          companyName
        }
      })
    }), /*#__PURE__*/_jsx(Contact, {
      chatUrl: chatUrl,
      supportUrl: supportUrl,
      email: email,
      facebookUrl: facebookUrl,
      hasZorseChatScope: hasZorseChatScope,
      hasZorseWebticketScope: hasZorseWebticketScope,
      homemade: homemade,
      isCustomer: isCustomer,
      onTrackInteraction: trackInteraction,
      openHelpWidget: openHelpWidget,
      phone: phone
    }), /*#__PURE__*/_jsx(DescriptionList, {
      paddingBlockStart: "200",
      children: /*#__PURE__*/_jsx(Section, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.overview.sidebar.support.supportedLanguages"
        }),
        children: renderedSupportLanguagesList
      })
    })]
  }), [chatUrl, companyName, email, facebookUrl, hasZorseChatScope, hasZorseWebticketScope, homemade, isCustomer, renderedSupportLanguagesList, supportUrl, trackInteraction, phone, name]);
  const renderedPrivacySection = useMemo(() => /*#__PURE__*/_jsxs(SidebarSection, {
    "data-test-id": "details-privacy",
    children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.overview.sidebar.privacy.headingText"
      })
    }), /*#__PURE__*/_jsx(Privacy, {
      homemade: homemade,
      onTrackInteraction: trackInteraction,
      privacyUrl: privacyUrl,
      privacy2Url: privacy2Url,
      privacy3Url: privacy3Url,
      termsUrl: termsUrl
    })]
  }), [homemade, trackInteraction, privacyUrl, privacy2Url, privacy3Url, termsUrl]);
  const renderedReportLink = useMemo(() => {
    return isCustomer && hasZorseWebticketScope ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "medium"
      }), /*#__PURE__*/_jsx(SidebarSection, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "appMarketplace.detail.overview.sidebar.reportApp_jsx",
          options: {
            onClick: () => {
              trackInteraction('click report this app link', {
                section: 'report'
              });
              openHelpWidget({
                create: true
              });
            }
          },
          elements: {
            Link
          }
        })
      })]
    }) : /*#__PURE__*/_jsx(Fragment, {});
  }, [isCustomer, hasZorseWebticketScope, trackInteraction]);
  const socialImageUrl = useSocialScreenshotUrl();
  const renderedFeatureCompatibilityModal = useMemo(() => {
    const inAppOrPublicContext = isCustomer ? 'app' : 'public';
    const onClose = () => {
      setFeatureCompatibilityModalOpen(false);
      // remove the query param from the URL so
      // the modal doesn't open again on refresh
      if (embeddedFeatureCompatibility === 'true') {
        const urlObj = new URL(window.location.href);
        urlObj.searchParams.delete('embeddedFeatureCompatibility');
        window.history.replaceState({}, '', urlObj);
      }
    };
    const tierGroupNames = ['CRM', 'OPERATIONS', 'MARKETING', 'SALES', 'SERVICE', 'CONTENT'];
    if (features !== null && features !== void 0 && features.length) {
      return /*#__PURE__*/_jsx(FeatureCompatibilityModal, {
        appContext: inAppOrPublicContext,
        features: features,
        installability: installability,
        onClose: onClose,
        tierGroupNames: tierGroupNames,
        trackInteraction: trackInteraction
      });
    } else {
      // If there are no feature editor defined features,
      // we'll call useCompatibility to build out the modal
      // with the deprecated /v1/compatibility/opsHub endpoint
      return /*#__PURE__*/_jsx(LegacyFeatureCompatibilityModal, {
        appContext: inAppOrPublicContext,
        integrationFeatures: integrationFeatures,
        onClose: onClose,
        tierGroupNames: tierGroupNames,
        trackInteraction: trackInteraction
      });
    }
  }, [isCustomer, features, installability, integrationFeatures, trackInteraction, embeddedFeatureCompatibility, setFeatureCompatibilityModalOpen]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [isPreview && !isAdminPreview && /*#__PURE__*/_jsx(Alert, {
      titleText: unescapedText('appMarketplace.detail.previewAlert.titleText'),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.previewAlert.message"
      })
    }), /*#__PURE__*/_jsxs(ListingPage, {
      contentAreaFlush: true,
      headerComponent: /*#__PURE__*/_jsx(NavMarker, {
        name: "DETAIL_HEADER_LOAD",
        children: /*#__PURE__*/_jsx(MainSectionInner, {
          children: /*#__PURE__*/_jsx(Header, {
            activeTab: activeTab,
            appId: appId,
            appName: name,
            appUrl: appUrl,
            credentials: credentials,
            connectionType: connectionType,
            iconUrl: iconUrl,
            interactionDetails: interactionDetails,
            isCustomer: isCustomer,
            isPreview: isPreview,
            isDataSyncApp: opsHub,
            isDashworksApp: dashworks,
            features: features,
            listingId: id,
            offeringId: offeringId,
            onConnectButtonClick: trackConnectButtonClick,
            onTrackEvent: trackEvent,
            onTrackInteraction: trackInteraction,
            onTrackPageview: trackPageview,
            scrollToTabSection: scrollToTabSection,
            setupUrl: setupUrl,
            tagline: tagline
          })
        })
      }),
      mainSectionBackgroundColor: trellisTheme.color['do-not-use-olaf'],
      pageBackgroundColor: trellisTheme.color['do-not-use-gypsum'],
      pageLayout: "full-width",
      children: [/*#__PURE__*/_jsx(MainSection, {
        id: "overview",
        children: /*#__PURE__*/_jsx(MainSectionInner, {
          children: /*#__PURE__*/_jsxs(Grid, {
            children: [/*#__PURE__*/_jsxs(GridItem, {
              paddingInlineEnd: isMobileView ? undefined : '1300',
              size: {
                xs: 12,
                md: 8
              },
              children: [/*#__PURE__*/_jsx(InnerSection, {
                "data-test-id": "carousel",
                children: /*#__PURE__*/_jsx(MediaCarousel, {
                  items: mediaCarouselItems,
                  onItemClick: () => {
                    runLeadGen({
                      onTrackInteraction: trackInteraction,
                      section: 'overview',
                      action: 'CLICKED_IMAGE'
                    });
                  },
                  onTrackInteraction: _ref => {
                    let {
                        action
                      } = _ref,
                      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
                    return trackInteraction(action, Object.assign({
                      section: 'overview'
                    }, rest));
                  }
                })
              }), /*#__PURE__*/_jsxs(InnerSection, {
                children: [/*#__PURE__*/_jsx(MainSectionHeading, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "appMarketplace.detail.overview.headingText",
                    options: {
                      name
                    }
                  })
                }), /*#__PURE__*/_jsx(Benefits, {
                  benefits: benefits
                })]
              }), /*#__PURE__*/_jsxs(InnerSection, {
                id: "features",
                "data-test-id": "details-integrations",
                children: [/*#__PURE__*/_jsx(View, {
                  marginBlockEnd: "600",
                  children: /*#__PURE__*/_jsx(InnerSectionHeading, {
                    itemRight: features !== null && features !== void 0 && features.length && installability || opsHub ? /*#__PURE__*/_jsx(Button, {
                      use: "link",
                      onClick: () => {
                        setFeatureCompatibilityModalOpen(true);
                        trackInteraction('click compare features by plan', {
                          section: 'overview'
                        });
                      },
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "appMarketplace.detail.overview.integrationFeatures.compatibilityLink"
                      })
                    }) : null,
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "appMarketplace.detail.overview.integrationFeatures.headingText",
                      options: {
                        name
                      }
                    })
                  })
                }), features !== null && features !== void 0 && features.length ? /*#__PURE__*/_jsx(FeatureCards, {
                  features: features,
                  installability: installability,
                  isPreview: isPreview,
                  onTrackInteraction: trackInteraction,
                  openFeatureCompatibilityModal: () => setFeatureCompatibilityModalOpen(true)
                }) : /*#__PURE__*/_jsx(IntegrationFeatures, {
                  integrationFeatures: integrationFeatures,
                  isOpsHubListing: opsHub,
                  onTrackInteraction: trackInteraction
                })]
              }), /*#__PURE__*/_jsxs(InnerSection, {
                id: "sharedData",
                children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "appMarketplace.detail.overview.sharedData.headingText"
                  })
                }), /*#__PURE__*/_jsx(SharedData, {
                  dataSyncHowItWorks: dataSyncHowItWorks,
                  dataSyncInfo: dataSyncInfo,
                  dataSyncs: dataSyncs,
                  iconUrl: iconUrl,
                  name: name,
                  onTrackInteraction: trackInteraction,
                  opsHub: opsHub
                })]
              }), /*#__PURE__*/_jsxs(InnerSection, {
                children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "appMarketplace.detail.overview.hubspotFeatures.headingText",
                    options: {
                      name
                    }
                  })
                }), /*#__PURE__*/_jsx(HubSpotFeatures, {
                  hubspotFeatures: hubSpotFeatures,
                  getFilterLink: getFilterLink,
                  isPreview: isPreview
                })]
              }), !!appIntegrations.length && /*#__PURE__*/_jsxs(InnerSection, {
                children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "appMarketplace.detail.overview.appIntegrations.headingText",
                    options: {
                      name
                    }
                  })
                }), /*#__PURE__*/_jsx(AppIntegrations, {
                  integrations: appIntegrations
                })]
              })]
            }), /*#__PURE__*/_jsxs(GridItem, {
              paddingBlockStart: isMobileView ? '600' : '0',
              size: {
                xs: 12,
                md: 4
              },
              children: [appContext === 'app' && /*#__PURE__*/_jsx(AppRelatedInstallStatsSection, {
                offeringId: offeringId
              }), /*#__PURE__*/_jsxs(SidebarSection, {
                children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "appMarketplace.detail.overview.sidebar.details.headingText"
                  })
                }), /*#__PURE__*/_jsx(AppDetails, {
                  appLanguages: appLanguages,
                  categoryV2: categoryV2,
                  companyName: companyName,
                  companyUrl: companyUrl,
                  homemade: homemade,
                  installs: installsCount,
                  isPreview: isPreview,
                  onTrackInteraction: trackInteraction
                })]
              }), /*#__PURE__*/_jsxs(SidebarSection, {
                children: [/*#__PURE__*/_jsx(InnerSectionHeading, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "appMarketplace.detail.overview.sidebar.requirements.headingText"
                  })
                }), /*#__PURE__*/_jsx(Requirements, {
                  appContext: appContext,
                  appName: name,
                  companyName: companyName,
                  connectionType: connectionType,
                  homemade: homemade,
                  iconUrl: iconUrl,
                  installability: installability,
                  features: features,
                  integrationFeatures: integrationFeatures,
                  isOpsHubListing: opsHub,
                  neededScopeGroups: neededScopeGroups,
                  onOpenFeatureCompatibilityModal: () => setFeatureCompatibilityModalOpen(true),
                  onTrackInteraction: trackInteraction,
                  pricingUrl: pricingUrl,
                  pricings: pricings,
                  scrollToTabSection: scrollToTabSection,
                  tabIds: TAB_IDS,
                  tiers: tiers
                })]
              }), !isMobileView && /*#__PURE__*/_jsxs(Fragment, {
                children: [renderedResourcesSection, renderedSupportSection, renderedPrivacySection, renderedReportLink]
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(MainSection, {
        color: "light",
        id: "pricing",
        children: /*#__PURE__*/_jsxs(MainSectionInner, {
          children: [/*#__PURE__*/_jsx(MainSectionHeading, {
            itemRight: /*#__PURE__*/_jsxs(Fragment, {
              children: [agencyPricingUrl && /*#__PURE__*/_jsx(Button, {
                external: true,
                href: getFormattedUrl(agencyPricingUrl) || undefined,
                onClick: () => trackInteraction('click agency pricing link', {
                  section: 'pricing'
                }),
                use: "link",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "appMarketplace.detail.pricing.agencyPricingLinkText"
                })
              }), pricingUrl && /*#__PURE__*/_jsx(Button, {
                external: true,
                href: getFormattedUrl(pricingUrl) || undefined,
                onClick: () => trackInteraction('click software pricing link', {
                  section: 'pricing'
                }),
                use: "link",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "appMarketplace.detail.pricing.pricingLinkText"
                })
              })]
            }),
            subheading: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.detail.pricing.subheadingText",
              options: {
                name
              }
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.detail.pricing.headingText",
              options: {
                name
              }
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Pricings, {
              currency: currency,
              onTrackInteraction: trackInteraction,
              pricings: pricings
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: "appMarketplace.detail.pricing.disclaimerText_jsx",
                elements: {
                  b: 'b',
                  Date: FormattedDateTime
                },
                options: {
                  format: 'L',
                  type: isCustomer ? 'portalTz' : 'utc',
                  value: pricingLastUpdated
                }
              })
            })
          })]
        })
      }), isMobileView && /*#__PURE__*/_jsx(MainSection, {
        color: "light",
        children: /*#__PURE__*/_jsxs(MainSectionInner, {
          children: [renderedResourcesSection, renderedSupportSection, renderedPrivacySection, renderedReportLink]
        })
      }), /*#__PURE__*/_jsx(MainSection, {
        children: /*#__PURE__*/_jsx(MainSectionInner, {
          id: "reviews",
          children: /*#__PURE__*/_jsx(FoundationsSection, {
            children: /*#__PURE__*/_jsx(Reviews, {
              allReviewsHref: getAllReviewsUrl(isPublic, slug),
              appName: name,
              appIcon: iconUrl,
              isPreview: isPreview,
              isReviewLink: isReviewLink,
              listingDetailUrl: getListingDetailUrl(slug),
              offeringId: offeringId,
              offeringPortalId: offeringPortalId || 0,
              slug: slug,
              supportLink: companyUrl,
              trackInteraction: trackReviewInteraction
            })
          })
        })
      }), !isCustomer && /*#__PURE__*/_jsx(MainSection, {
        color: "dark",
        children: /*#__PURE__*/_jsx(InnerSection, {
          children: /*#__PURE__*/_jsx(AsyncCtaBanner, {
            appName: name,
            appLink: pricingUrl,
            companyName: companyName,
            companyUrl: companyUrl,
            homemade: homemade,
            pathname: pathname,
            onTrackInteraction: trackInteraction
          })
        })
      }), featureCompatibilityModalOpen && renderedFeatureCompatibilityModal]
    }), /*#__PURE__*/_jsx(PublicOnly, {
      children: /*#__PURE__*/_jsxs(DocumentHead, {
        children: [/*#__PURE__*/_jsx(CanonicalLink, {
          to: url
        }), /*#__PURE__*/_jsx("meta", {
          name: "description",
          content: tagline
        }), /*#__PURE__*/_jsx("meta", {
          name: "keywords",
          content: keywords.join(',')
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "card"
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "site"
        }), /*#__PURE__*/_jsx(MetaTwitter, {
          name: "image",
          content: socialImageUrl
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "type"
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "title",
          content: documentTitle
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "url",
          content: getFullHref(url)
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "description",
          content: tagline
        }), /*#__PURE__*/_jsx(MetaOpenGraph, {
          property: "image",
          content: socialImageUrl
        }), /*#__PURE__*/_jsx(PrerenderReady, {})]
      })
    })]
  });
}